import { Arg, Entity, Field, Mutation } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { baseConfig } from '@adornis/config/baseConfig.js';
import { sendDigitaleHeldenMail } from '@adornis/digitale-helden-shared/features/mailing/server/mailer.js';
import { contactFormTemplate } from '@adornis/digitale-helden-shared/features/mailing/server/templates/contact-form-template.js';
import { Recipient } from '@adornis/mails/db/recipients.js';
import { Message } from '@adornis/mails/server/communication.js';
import { emailRegexCheck } from '@adornis/users/db/validators.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class ContactFormData extends AdornisEntity {
  static override _class = 'ContactFormData';

  @validate(nonOptional())
  @Field(type => String)
  firstName!: string;

  @validate(nonOptional())
  @Field(type => String)
  lastName!: string;

  @validate(options => {
    if (!emailRegexCheck(options.value))
      throw new ValidationError('Bitte gib eine gültige E-Mail an.', {
        key: options.key,
        translationKey: 'validation_email',
      });
  })
  @Field(type => String)
  email!: string;

  @validate(nonOptional())
  @Field(type => String)
  message!: string;

  @Field(type => Boolean) isNewsletter!: boolean;
  @Field(type => Boolean) isWebinar!: boolean;

  @Mutation(type => String)
  static sendContactEmail(@Arg('data', type => ContactFormData) data: ContactFormData) {
    return async () => {
      await sendDigitaleHeldenMail({
        message: async (webversionLink: string) =>
          await Message.compose(
            await contactFormTemplate({
              firstName: data.firstName,
              lastName: data.lastName,
              email: data.email,
              message: data.message,
              webmailLink: webversionLink,
            }),
          ),
        recipients: [
          baseConfig.get('DEPLOYMENT') === 'development'
            ? new Recipient(['michael@adornis.de', 'test@adornis.de'])
            : new Recipient('support@digitale-helden.de'),
        ],
      });
    };
  }
}
